/*
 * Copyright (c) 2022-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { STEPS_REQUIRING_CUSTOM_LINK } from '../../constants';
import {
  LinkElement,
  TransformStepFnWithOptions,
} from '../../types';
import {
  getFactorPageCustomLink,
  isPasswordRecovery,
} from '../../util';

export const transformFactorPageCustomLink: TransformStepFnWithOptions = ({
  transaction,
  widgetProps,
}) => (
  formbag,
) => {
  const shouldAddButton = !isPasswordRecovery(transaction) && transaction.availableSteps
    ?.some(({ name }) => STEPS_REQUIRING_CUSTOM_LINK.includes(name));
  if (!shouldAddButton) {
    return formbag;
  }

  const factorPageCustomLink = getFactorPageCustomLink(widgetProps);
  if (factorPageCustomLink) {
    const { href, text } = factorPageCustomLink;
    const customLink: LinkElement = {
      type: 'Link',
      contentType: 'footer',
      options: {
        href,
        target: '_blank',
        step: '',
        label: text,
        dataSe: 'factorPageHelpLink',
      },
    };
    formbag.uischema.elements.push(customLink);
  }

  return formbag;
};
